import {useEffect, useState} from "react";
import styled from 'styled-components';

import {useHistory} from "react-router-dom";
import {FormControl, Input, Stack, Textarea, useToast} from "@chakra-ui/react";
import {Fullscreen, Main} from '../../components/fullscreen_view';
import Form from "../../components/form";
import useFeedback from "../../utils/use_feedback";
import {FixedTopBar} from "../../components/top_bar";
import {useSaveClicked} from "../../store";
import {useCreateCommunity} from "../../api/communities";
import {useReloadProfile} from "../../api/user";
import useModal from "../../modals";

const Heading = styled.div``;

const Create = styled(({className}) => {
    const history = useHistory();
    const modal = useModal();
    const toast = useToast();
    const {busy, error, feedbackCh} = useFeedback(true);

    const [community, setCommunity] = useState({
        name: '',
        displayName: '',
        description: '',
        politics: false,
        nsfw: false,
    });
    const set = (name) => (value) => setCommunity((community) => ({...community, [name]: value}));

    const createCommunity = useCreateCommunity(feedbackCh);
    const reloadProfile = useReloadProfile(feedbackCh);
    const save = async () => {
        try {
            await createCommunity(community.name, community.name, community.description, false, false);
            await reloadProfile();
            modal.open('CommunityOnboard', {community: community.name})
        } catch (error) {
        }
    };

    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    await save();
                    setSaving(false);
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);

    return (
        <Fullscreen className={className}>
            <FixedTopBar back title="Create a Community" border={false} black save={'Next'} />
            <Main>
                <Form autocomplete="off">

                        <Stack spacing={5}>

                            <FormControl>
                                <Heading>Community Name</Heading>
                                <Input type="title"
                                       placeholder={"Cats"}
                                       value={community.name}
                                       onChange={(e) => set('name')(e.currentTarget.value)}
                                       maxLength="20"
                                       autoComplete="off"/>
                            </FormControl>

                            <FormControl>
                                <Heading>Description</Heading>
                                <Textarea type="content" value={community.description} rows={6}
                                          placeholder="A community about cats."
                                          maxLength="255"
                                          onChange={(e) => set('description')(e.currentTarget.value)}
                                />
                            </FormControl>

                        </Stack>

                    {error && <p style={{marginTop: '12px'}}>{error.toString()}</p>}

                </Form>
            </Main>
        </Fullscreen>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'none' : theme.white_0};

  ${Form} {
    margin-top: 16px;
  }
  
  ${Main} {
    width: 100%;
    padding: 0 20px;
  }
  ${Heading} {
    font-weight: 600;
    font-size: 15px;
    padding: 6px 0;
  }

`;

export default Create;
